import React, { useEffect, useState } from "react";
import Sidebar from "../includes/Sidebar";
import MainHeading from "../includes/MainHeading";
import Footer from "../includes/Footer";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import AdminListService from "../../../services/admin-list.service";
import { useSelector } from "react-redux";
import { useFormik } from "formik";
import ReactLoading from "react-loading";
import { updateVoucher } from "../../../schema";
import moment from "moment";
import Skeleton from "react-loading-skeleton";

import $ from "jquery";
import ImageLoader from "../includes/ImageLoader";

export default function EditVoucher() {
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [formSubmiting, setFormSubmiting] = useState(false);
  const [tableLoader, settableLoader] = useState(false);
  const [startPoint, setStartPoint] = useState(1);
  const [productShow, setProductShow] = useState("");
  const [giftError, setGiftError] = useState(false);
  const [endPoint, setEndPoint] = useState(500);
  const [tableData, settableData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const [cardData, setCardData] = useState([]);
  const [errorsServer, setErrorsServer] = useState([]);
  const [allSelected, setAllSelected] = useState(true);

  const [selectedPr, setSelectedPr] = useState([]);

  const state = useSelector((state) => state.stateVals);
  const { adminAccessToken, admin_id } = state;
  const navigate = useNavigate();

  const giftsLists = async (start, end, choices) => {
    settableData([]);
    setFilteredData([]);
    setAllSelected(true);

    if (
      parseInt(start) <= parseInt(end) &&
      parseInt(start) > 0 &&
      parseInt(end) > 0
    ) {
      try {
        setProductShow("ok");
        settableLoader(true);

        const responce = await AdminListService.getGiftsByRange(start, end);

        const res = responce?.data?.response;

        const results = [];
        res.map((value) => {
          return results.push({
            CardName: value.name,
            CardImage: value.image,
            description: value.description,
            CardId: value.id,
            has_variants: value.has_variants,
          });
        });

        if (choices && choices.length) {
          const productsToAdd = await results.filter((product) =>
            choices.includes(parseInt(product.CardId))
          );

          await setSelectedPr(productsToAdd);
          const saveSelected = productsToAdd
            .filter((item) => item.CardId)
            .map((item) => item.CardId);

          await setCardData(saveSelected);
        } else {
          setSelectedPr([]);
          setCardData([]);
        }

        settableData([...results]);
        setFilteredData([...results]);
        settableLoader(false);
        setProductShow("ok");
        setStartPoint(start);
        setEndPoint(end);
      } catch (err) {
        console.log(err);
        settableData([]);
        setFilteredData([]);
        settableLoader(false);
        setProductShow("fail");
      }
    } else {
      toast.error("Points Range Invalid ", {
        position: "top-center",
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });

      settableLoader(false);
      setProductShow("fail");
    }
  };
  useEffect(() => {
    if (adminAccessToken) {
      const getSingleVoucher = async () => {
        setLoading(true);
        try {
          const response = await AdminListService.getVoucherByIdNew(id);

          setValues({
            Company: response?.data?.response?.company,
            Certificate: response?.data?.response?.certificate,

            First: response?.data?.response?.fname,
            Street: response?.data?.response?.address,
            State: response?.data?.response?.state,

            issuance:
              response?.data?.response?.issuance !== "" &&
              response?.data?.response?.issuance !== " " &&
              response?.data?.response?.issuance !== "0000-00-00" &&
              moment(response?.data?.response?.issuance).format("YYYY-MM-DD"),

            CertiStatus: response?.data?.response?.status,
            Job: response?.data?.response?.job,

            Last: response?.data?.response?.lname,
            City: response?.data?.response?.city,
            Zip: response?.data?.response?.zip,
            Expiration:
              response?.data?.response?.expiration !== "" &&
              response?.data?.response?.expiration !== " " &&
              response?.data?.response?.expiration !== "0000-00-00" &&
              moment(response?.data?.response?.expiration).format("YYYY-MM-DD"),
            Denomination: response?.data?.response?.denomination,
          });

          setLoading(false);
          setStartPoint(response?.data?.response?.denomination);
          setEndPoint(response?.data?.response?.denomination_end);
          giftsLists(
            response?.data?.response?.denomination,
            response?.data?.response?.denomination_end,
            response?.data?.response?.choices
          );
        } catch (err) {
          console.log(err);
          setLoading(false);

          if (
            err?.response?.data?.message &&
            typeof err?.response?.data?.message === "string"
          ) {
            toast.error(err?.response?.data?.message, {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          } else {
            toast.error("Something went wrong, try again", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
        }
      };
      getSingleVoucher();
    } else {
      navigate("/admin/login", { replace: true });
    }
    // eslint-disable-next-line
  }, []);

  const updateVoucherFun = async (values) => {
    var selectedCards = selectedPr
      .map((value) => {
        return value.CardId;
      })
      .join(",");
    if (!selectedCards.length) {
      setGiftError(true);
    } else {
      if (
        parseInt(startPoint) <= parseInt(endPoint) &&
        parseInt(startPoint) > 0 &&
        parseInt(endPoint) > 0
      ) {
        setFormSubmiting(true);
        setGiftError(false);
        try {
          const response = await AdminListService.updateVoucherById(
            values,
            admin_id,
            id,
            selectedCards,
            startPoint,
            endPoint
          );

          toast.success(response?.data?.response, {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setFormSubmiting(false);
          setTimeout(() => {
            navigate("/admin/vouchers", { replace: true });
          }, 1000);
        } catch (err) {
          console.log(err);
          setFormSubmiting(false);

          if (
            err?.response?.data?.response &&
            typeof err?.response?.data?.response === "string"
          ) {
            toast.error(err?.response?.data?.response, {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          } else {
            let errorData = {};

            errorData["Company"] =
              err.response?.data &&
              err.response?.data?.company &&
              err.response?.data?.company[0];
            errorData["Job"] =
              err.response?.data &&
              err.response?.data?.job &&
              err.response?.data?.job[0];
            errorData["Certificate"] =
              err.response?.data &&
              err.response?.data?.certificate &&
              err.response?.data?.certificate[0];
            errorData["Expiration"] =
              err.response?.data &&
              err.response?.data?.expiration &&
              err.response?.data?.expiration[0];

            errorData["First"] =
              err.response?.data &&
              err.response?.data?.fname &&
              err.response?.data?.fname[0];
            errorData["Last"] =
              err.response?.data &&
              err.response?.data?.lname &&
              err.response?.data?.lname[0];
            errorData["Street"] =
              err.response?.data &&
              err.response?.data?.address &&
              err.response?.data?.address[0];

            errorData["City"] =
              err.response?.data &&
              err.response?.data?.city &&
              err.response?.data?.city[0];

            errorData["State"] =
              err.response?.data &&
              err.response?.data?.state &&
              err.response?.data?.state[0];

            errorData["issuance"] =
              err.response?.data &&
              err.response?.data?.issuance &&
              err.response?.data?.issuance[0];

            errorData["Zip"] =
              err.response?.data &&
              err.response?.data?.zip &&
              err.response?.data?.zip[0];

            errorData["Denomination"] =
              err.response?.data &&
              err.response?.data?.denomination &&
              err.response?.data?.denomination[0];

            setErrorsServer(errorData);
            $("html, body").animate(
              {
                scrollTop: 0,
              },
              600
            );
            toast.error("Something went wrong, try again", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            handleButtonClick();
          }
        }
      } else {
        toast.error("Points Range Invalid ", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }
  };

  const {
    values,
    errors,
    touched,
    setValues,

    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: {
      Company: "",
      Certificate: "",
      First: "",
      Street: "",
      State: "",
      issuance: "",
      CertiStatus: "",
      Job: "",
      Last: "",
      City: "",
      Zip: "",
      Expiration: "",
    },
    validationSchema: updateVoucher,
    onSubmit: async () => {
      if (!selectedPr.length) {
        setGiftError(true);
      } else {
        await setGiftError(false);
        document.querySelector("#product-view").click();
      }
    },
  });

  const handleButtonClick = () => {
    setTimeout(() => {
      const firstError = document.querySelector(".error-message");
      if (firstError) {
        // firstError.scrollIntoView({ behavior: "smooth" });
        const rect = firstError.getBoundingClientRect();
        const offsetTop = rect.top - 200 + window.scrollY;

        window.scrollTo({
          top: offsetTop,
          behavior: "smooth",
        });
      }
    }, 500);
  };

  const allSelect = async () => {
    $(".gift-scroll input:checkbox").prop("checked", allSelected);
    const selectedIdz = selectedPr.map((item) => item.CardId);
    const productsToAdd = filteredData.filter(
      (product) => !selectedIdz.includes(product.CardId)
    );

    const productsAlreadyAdd = filteredData.filter((product) =>
      selectedIdz.includes(product.CardId)
    );
    if (allSelected) {
      setSelectedPr([...selectedPr, ...productsToAdd]);

      if (
        productsToAdd.length === filteredData.length ||
        selectedIdz.length === filteredData.length ||
        selectedIdz.length + productsToAdd.length === filteredData.length ||
        productsAlreadyAdd.length + productsToAdd.length === filteredData.length
      ) {
        setAllSelected(false);
      }
    } else {
      const searchedProductIds = filteredData.map((product) => product.CardId);

      const newFilter = selectedPr.filter(
        (item) => !searchedProductIds.includes(item.CardId)
      );
      setSelectedPr(newFilter);

      setAllSelected(true);
    }
  };

  const onCheckChange = (id) => {
    const index = selectedPr.findIndex((item) => item.CardId === id);
    if (index === -1) {
      const recordToAdd = filteredData.find((item) => item.CardId === id);
      if (recordToAdd) {
        setSelectedPr([...selectedPr, recordToAdd]);
      }
    } else {
      const newFilter = [...selectedPr];
      newFilter.splice(index, 1);
      setSelectedPr(newFilter);
    }
  };

  const handleSearch = (e) => {
    setProductShow("ok");
    const searchQuery = e.target.value.toLowerCase();
    // Filter the data based on the search query
    if (searchQuery !== "") {
      const newFilteredData = tableData.filter((item) => {
        // Customize this condition based on your data structure and search requirements
        return (
          item.description.toString().toLowerCase().includes(searchQuery) ||
          item.CardName.toString().toLowerCase().includes(searchQuery)
        );
      });

      setFilteredData(newFilteredData);
      if (newFilteredData.length) {
        setProductShow("ok");
        const searchedProductIds = newFilteredData.map(
          (product) => product.CardId
        );

        const newFilter = selectedPr.filter((item) =>
          searchedProductIds.includes(item.CardId)
        );
        if (newFilteredData.length === newFilter.length) {
          setAllSelected(false);
        } else {
          setAllSelected(true);
        }
      } else {
        setProductShow("fail");
      }
    } else {
      setFilteredData(tableData);
      setAllSelected(true);
    }
  };

  useEffect(() => {
    if (selectedPr.length) {
      const saveSelected = selectedPr
        .filter((item) => item.CardId)
        .map((item) => item.CardId);

      setCardData(saveSelected);
    } else {
      setCardData([]);
    }
  }, [selectedPr]);

  return (
    <div className="wrapper">
      <main className="page-content customer-contnent">
        <div className="site-main-design">
          <Sidebar />
          <MainHeading heading="Update Voucher" />

          <form className="mt-4 row" onSubmit={handleSubmit} noValidate>
            <div className="col-md-12 col-12">
              <div className="card dashboard-cards">
                <div className="bg-white  py-3 card-header">
                  <h4 className="mb-0">Edit Your Voucher</h4>
                </div>
                <div className="card-body">
                  {loading ? (
                    <Skeleton
                      count={12}
                      height="58px"
                      width="23.5%"
                      inline={true}
                      className="m-2"
                    />
                  ) : (
                    <div className="row">
                      <div className="col-md-3">
                        <div className="input-field-box">
                          <label>
                            Company <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Company"
                            onChange={handleChange}
                            name="Company"
                            value={values.Company || ""}
                          />
                          {errors.Company && touched.Company ? (
                            <span className="text-danger error-message">
                              {errors.Company}
                            </span>
                          ) : errorsServer.Company ? (
                            <span className="text-danger error-message">
                              {errorsServer.Company}
                            </span>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="input-field-box">
                          <label>
                            Job <span className="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Job"
                            onChange={handleChange}
                            name="Job"
                            value={values.Job || ""}
                          />
                          {errors.Job && touched.Job ? (
                            <span className="text-danger error-message">
                              {errors.Job}
                            </span>
                          ) : errorsServer.Job ? (
                            <span className="text-danger error-message">
                              {errorsServer.Job}
                            </span>
                          ) : null}
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="input-field-box">
                          <label>
                            Certificate <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Certificate"
                            onChange={handleChange}
                            name="Certificate"
                            value={values.Certificate || ""}
                          />
                          {errors.Certificate && touched.Certificate ? (
                            <span className="text-danger error-message">
                              {errors.Certificate}
                            </span>
                          ) : errorsServer.Certificate ? (
                            <span className="text-danger error-message">
                              {errorsServer.Certificate}
                            </span>
                          ) : null}
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="input-field-box">
                          <label>
                            First Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="First Name"
                            onChange={handleChange}
                            name="First"
                            value={values.First || ""}
                          />
                          {errors.First && touched.First ? (
                            <span className="text-danger error-message">
                              {errors.First}
                            </span>
                          ) : errorsServer.First ? (
                            <span className="text-danger error-message">
                              {errorsServer.First}
                            </span>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="input-field-box">
                          <label>
                            Last Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Last Name"
                            onChange={handleChange}
                            name="Last"
                            value={values.Last || ""}
                          />
                          {errors.Last && touched.Last ? (
                            <span className="text-danger error-message">
                              {errors.Last}
                            </span>
                          ) : errorsServer.Last ? (
                            <span className="text-danger error-message">
                              {errorsServer.Last}
                            </span>
                          ) : null}
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="input-field-box">
                          <label>
                            Address <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Address"
                            onChange={handleChange}
                            name="Street"
                            value={values.Street || ""}
                          />
                          {errors.Street && touched.Street ? (
                            <span className="text-danger error-message">
                              {errors.Street}
                            </span>
                          ) : errorsServer.Street ? (
                            <span className="text-danger error-message">
                              {errorsServer.Street}
                            </span>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="input-field-box">
                          <label>
                            City <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="City"
                            onChange={handleChange}
                            name="City"
                            value={values.City || ""}
                          />
                          {errors.City && touched.City ? (
                            <span className="text-danger error-message">
                              {errors.City}
                            </span>
                          ) : errorsServer.City ? (
                            <span className="text-danger error-message">
                              {errorsServer.City}
                            </span>
                          ) : null}
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="input-field-box">
                          <label>
                            State <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="State"
                            onChange={handleChange}
                            name="State"
                            value={values.State || ""}
                          />
                          {errors.State && touched.State ? (
                            <span className="text-danger error-message">
                              {errors.State}
                            </span>
                          ) : errorsServer.State ? (
                            <span className="text-danger error-message">
                              {errorsServer.State}
                            </span>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="input-field-box">
                          <label>
                            Zip <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Zip"
                            onChange={handleChange}
                            name="Zip"
                            value={values.Zip || ""}
                          />
                          {errors.Zip && touched.Zip ? (
                            <span className="text-danger error-message">
                              {errors.Zip}
                            </span>
                          ) : errorsServer.Zip ? (
                            <span className="text-danger error-message">
                              {errorsServer.Zip}
                            </span>
                          ) : null}
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="input-field-box">
                          <label>Begin Redemption</label>
                          <input
                            type="date"
                            className="form-control"
                            onChange={handleChange}
                            name="issuance"
                            value={values.issuance || ""}
                          />
                          {errors.issuance && touched.issuance ? (
                            <span className="text-danger error-message">
                              {errors.issuance}
                            </span>
                          ) : errorsServer.issuance ? (
                            <span className="text-danger error-message">
                              {errorsServer.issuance}
                            </span>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="input-field-box">
                          <label>Expiration</label>
                          <input
                            type="date"
                            className="form-control"
                            onChange={handleChange}
                            name="Expiration"
                            value={values.Expiration || ""}
                          />
                          <span className="text-danger">
                            (MM/DD/YYYY) eg : 12/25/2014
                          </span>
                          {errors.Expiration && touched.Expiration ? (
                            <span className="text-danger error-message">
                              {errors.Expiration}
                            </span>
                          ) : errorsServer.Expiration ? (
                            <span className="text-danger error-message">
                              {errorsServer.Expiration}
                            </span>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="input-field-box mb-md-0">
                          <label>Certificate Status</label>
                          <input
                            type="text"
                            className={`form-control text-capitalize ${
                              values.CertiStatus === "active" ||
                              values.CertiStatus === "Valid"
                                ? "text-success"
                                : values.CertiStatus === "used"
                                ? "text-primary"
                                : values.CertiStatus === "expired" ||
                                  values.CertiStatus === "archive"
                                ? "text-danger"
                                : ""
                            }`}
                            onChange={handleChange}
                            name="CertiStatus"
                            value={values.CertiStatus || ""}
                            readOnly={true}
                          />
                          {errors.CertiStatus && touched.CertiStatus ? (
                            <span className="text-danger error-message">
                              {errors.CertiStatus}
                            </span>
                          ) : errorsServer.CertiStatus ? (
                            <span className="text-danger error-message">
                              {errorsServer.CertiStatus}
                            </span>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                {/* <div className="card-footer text-center">
                  <button
                    className="btn btn-primary "
                    type="submit"
                    onClick={handleButtonClick}
                  >
                    Update Voucher
                  </button>
                </div> */}
              </div>
            </div>

            {selectedPr.length ? (
              <div className="mt-4  col-xl-12 col-lg-12 col-md-12 col-12">
                <div className="card dashboard-cards">
                  <div className="bg-white  py-3 card-header">
                    <h4 className="mb-0">Selected Products</h4>
                  </div>
                  <div className="gift-scroll gift-lists">
                    <div className="card-body on-off-cards">
                      <div className="row gy-4">
                        {selectedPr.map((el) => (
                          <div
                            className="col-12 col-md-4 col-lg-2 text-center"
                            key={el.CardId}
                          >
                            <div className="form-check form-switch">
                              <label className="form-check-label form-check-label-with-text mb-0  ">
                                <span className="card-name-text">
                                  {el.CardName}
                                </span>
                                {el.has_variants ? (
                                  <img
                                    src={el.CardImage}
                                    className="card_logo_img"
                                    alt="card pic"
                                  />
                                ) : (
                                  <ImageLoader cardImg={el.CardImage} />
                                )}
                              </label>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
            <div className="mt-4  col-md-12 col-12">
              <div
                className={`card dashboard-cards ${
                  giftError ? "error-card" : ""
                }`}
              >
                {giftError ? (
                  <span className="text-danger">Please select a product</span>
                ) : null}
                <div className="bg-white  py-3 card-header">
                  <div className="row">
                    <div className="col-md-8">
                      <h4 className="mb-0">Select Points Range For Products</h4>
                    </div>
                    <div className="col-md-4 text-end">
                      <button className="btn btn-primary " type="submit">
                        Update Voucher
                      </button>
                    </div>
                  </div>
                </div>
                <div className="card-body pb-0">
                  <div className="row">
                    <div className="col-md-5">
                      <div className="input-field-box mb-lg-0">
                        <label>From</label>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            min={1}
                            onChange={(e) => {
                              if (/[^0-9]/.test(e.target.value)) {
                                setStartPoint(startPoint);
                                settableData([]);
                                setFilteredData([]);
                                setSelectedPr([]);
                              } else if (e.target.value.length > 0) {
                                if (e.target.value > 0) {
                                  setStartPoint(e.target.value);
                                  settableData([]);
                                  setSelectedPr([]);
                                  setFilteredData([]);
                                }
                              } else {
                                setStartPoint("");
                                settableData([]);
                                setSelectedPr([]);
                                setFilteredData([]);
                              }
                            }}
                            value={startPoint}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-7">
                      <div className="input-field-box mb-lg-0">
                        <label>To</label>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            min={1}
                            onChange={(e) => {
                              if (/[^0-9]/.test(e.target.value)) {
                                setEndPoint(endPoint);
                                settableData([]);
                                setSelectedPr([]);
                                setFilteredData([]);
                              } else if (e.target.value.length > 0) {
                                if (e.target.value > 0) {
                                  setEndPoint(e.target.value);
                                  settableData([]);
                                  setSelectedPr([]);
                                  setFilteredData([]);
                                }
                              } else {
                                setEndPoint("");
                                settableData([]);
                                setSelectedPr([]);
                                setFilteredData([]);
                              }
                            }}
                            value={endPoint}
                          />
                          <button
                            className="btn btn-primary"
                            type="button"
                            onClick={(e) => {
                              giftsLists(startPoint, endPoint);
                            }}
                          >
                            Search
                          </button>
                          <button
                            className="btn btn-primary"
                            type="button"
                            onClick={() => {
                              window.location.reload();
                            }}
                          >
                            Reset
                          </button>
                          {filteredData.length ? (
                            <button
                              className="btn btn-success  "
                              type="button"
                              onClick={allSelect}
                            >
                              {allSelected ? "Select " : "Unselect "}
                              All
                            </button>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    {tableData.length ? (
                      <div className="col-md-12 my-4">
                        <div className="input-field-box mb-lg-0">
                          <label>Search product by name and description </label>
                          <div className="input-group">
                            <input
                              type="text"
                              className="form-control"
                              onChange={(e) => {
                                handleSearch(e);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="gift-scroll gift-lists">
                  <div className="card-body on-off-cards">
                    {productShow === "ok" ? (
                      tableLoader ? (
                        <Skeleton
                          count={20}
                          height="180px"
                          width="18.9%"
                          inline={true}
                          className="m-2"
                        />
                      ) : (
                        <div className="row">
                          {filteredData.length
                            ? filteredData.map((el) => (
                                <div
                                  className="col-12 col-md-4 col-lg-2 text-center"
                                  key={el.CardId}
                                >
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={`gift${el.CardId}`}
                                      value={el.CardId}
                                      onChange={() => {
                                        onCheckChange(el.CardId);
                                      }}
                                      defaultChecked={
                                        cardData?.includes(el.CardId)
                                          ? true
                                          : false
                                      }
                                    />
                                    <label
                                      className="form-check-label form-check-label-with-text mt-2"
                                      htmlFor={`gift${el.CardId}`}
                                    >
                                      <span className="card-name-text">
                                        {el.CardName}
                                      </span>
                                      {el.has_variants ? (
                                        <img
                                          src={el.CardImage}
                                          className="card_logo_img"
                                          alt="card pic"
                                        />
                                      ) : (
                                        <ImageLoader cardImg={el.CardImage} />
                                      )}
                                    </label>
                                  </div>
                                </div>
                              ))
                            : null}
                        </div>
                      )
                    ) : productShow === "fail" ? (
                      <h4 className="mb-0 text-danger">No Product Found</h4>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </form>
          <button
            type="button"
            className="d-none"
            id="product-view"
            data-bs-toggle="modal"
            tabIndex="-3"
            data-bs-target="#staticBackdrop"
          ></button>

          <div
            className="modal fade"
            id="staticBackdrop"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable product-scroll">
              <div className="modal-content">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="staticBackdropLabel">
                    Selected Points Range and Products
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="card-body on-off-cards">
                    <div className="row">
                      <div className="col-md-12 mb-2">
                        <h5>
                          Points Range:
                          <span className="text-primary-color fw-bold">
                            {startPoint + " To " + endPoint}
                          </span>
                        </h5>
                      </div>

                      {selectedPr.length
                        ? selectedPr.map((el) => (
                            <div
                              className="col-12 col-md-4 col-lg-2 text-center"
                              key={el.CardId}
                            >
                              <div className="form-check form-switch">
                                <label className="form-check-label form-check-label-with-text ">
                                  <span className="card-name-text">
                                    {el.CardName}
                                  </span>
                                  {el.has_variants ? (
                                    <img
                                      src={el.CardImage}
                                      className="card_logo_img"
                                      alt="card pic"
                                    />
                                  ) : (
                                    <ImageLoader cardImg={el.CardImage} />
                                  )}
                                </label>
                              </div>
                            </div>
                          ))
                        : null}
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  {selectedPr.length ? (
                    <button
                      type="button"
                      className="btn btn-primary"
                      data-bs-dismiss="modal"
                      onClick={() => {
                        updateVoucherFun(values);
                      }}
                    >
                      Submit
                    </button>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
      {formSubmiting && (
        <ReactLoading
          type="spinningBubbles"
          color="#185791"
          className="bar-loader"
        />
      )}
    </div>
  );
}
